import {
  TDoorCostExtraInfo,
  TDoorCostGeneralInfo,
} from 'features/suppliers-management/door-cost/types';
import {
  ListItemQueryResponse,
  QueryPaginationParams,
} from 'lib/rtkQuery/types';

export enum DOOR_COST_REPORT_PAGE_TYPE {
  REVENUE = 'revenue',
  EXPENSE = 'expense',
}

export type TDoorCostExpenseItem = TDoorCostExtraInfo & {
  customer_name: string;
};

export type TDoorCostReportItem = TDoorCostGeneralInfo & {
  details: TDoorCostExtraInfo[];
};

export type TGetDoorCostReportQueryResponse = ListItemQueryResponse<
  TDoorCostReportItem[]
> & {
  report: TDoorCostReport;
};

export type TDoorCostReport = {
  total_revenue: number;
  total_cost: number;
  total_doors: number;
  total_details: number;
};

export type TGetDoorCostReportQueryParams =
  QueryPaginationParams<TDoorCostGeneralInfo> & {
    customer_name?: string;
    pol?: string;
    pod?: string;
    pickup_date_from?: string;
    pickup_date_to?: string;
    discharge_date_from?: string;
    discharge_date_to?: string;
    vessel_name?: string;
    voyage_code?: string;
  };
